import BaseApi from './base'

class PersIOTMessage extends BaseApi {
  getPersIOTMessages = (query) => this.client.get(`log-iot-message?${query}`)
}

export default new PersIOTMessage()
